import { DefaultLayers } from "../../src/utils/Layers";
import ViewManager from "../../src/utils/ViewManager";
import ReelGroup from "../../src/views/ReelGroup";
import GameEvents from "../const/GameEvents";
import SpinModel from "../model/SpinModel";
import { State } from "./State";
import App from "../../../core/src/App";
import requestRegister from "../server/requests/RequestRegister";
import BetModel from "../model/BetModel";
import CommManager from "../../src/controllers/CommManager";
import UIController from "../../src/ui/UIController";
import { UIModes, UIStates } from "../../src/ui/UIStates";
import ErrorModel from "../model/ErrorModel";
import { ClearWinFieldCommand } from "../commands/GameCommands";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import { UIUpdateEvent } from "../ui/UIUpdateEvents";
import AutoplayModel from "../model/AutoplayModel";
import { UIComponents } from '../ui/UIComponents';
import { Tween } from "../Tween";
import { VendorCommandsEnum } from "../../../src/commands/VendorCommandsEnum";
import ConsoleUtil from "../utils/ConsoleUtil";
import VendorModel from "../../../src/model/VendorModel";

export default abstract class SpinStartState extends State {
    public enter(): void {
        super.enter();
        
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.hideLinesAndInfo(true);
        if (AutoplayModel.isAutoSpinActive()) {
            if(!SpinModel.isInFreespins()) {
                UIController.setMode(UIStates.AUTO);
                UIController.setState(UIStates.AUTO);
            }
        } else {
            UIController.setState(UIStates.SPIN);
        }
        this.startSpin();
        if (!SpinModel.isInFreespins() && !AutoplayModel.isAutoSpinActive() && !SpinModel.inFreegames() && !SpinModel.isInRespins()) {
            CommandManager.execute(Commands.CLEAR_WIN);
        }
    }



    protected startSpin() {
        // In free spins usually we start with some accumulated win,
        // so we mustn't clear it.
        // if (!SpinModel.isInFreespins()) {
        //     SpinModel.accumulatedWin = 0;
        // }

        if (SpinModel.inFreegames()) {
            // TODO: remove this code! Never assign SpinModel data directly! 
            // Also: VendorModel is placed at vendor_core, not at core!!!
            SpinModel.accumulatedWin = VendorModel.freeGames.win;
            CommandManager.execute(Commands.UPDATE_WIN, VendorModel.freeGames);
        }

        if (AutoplayModel.hasAutospinStarted()) {
            App.timeline.add(Tween.delayedCall(App.config.autoSpinDelay, () => {
                if (!SpinModel.inFreegames()) {
                    CommandManager.execute(Commands.CLEAR_WIN);
                }

                this.initReel();
                this.sendRequest();
            }), App.timeline.time);
        } else {
            this.initReel();
            this.sendRequest();
        }
        // SoundController.playSound(SoundVars.EFFECT_REEL_SPIN, true, 1);
        App.dispatcher.emit(GameEvents.START_SPIN);
        App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);
    }

    abstract sendRequest(): void;

    protected initReel() {
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        reelGroup.spin();
    }

    protected onResponse(data?: any) {
        SpinModel.update(data);
        ErrorModel.update(data);

        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.DECREMENT_AUTOPLAY);
        }

        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
            BetModel.update(data);
            UIController.updateFields(UIUpdateEvent.Balance);
        } else {
            this.anounce();
        }

        this.updateFields();
        this.exit();
    }

    protected updateFields() {
        if (SpinModel.isInFreespins()) {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            )
        } else {
           // CommandManager.execute(Commands.CLEAR_WIN);
        }
        CommandManager.execute(Commands.UPDATE_BALANCE);
    }

    protected anounce() {
        if (
            ViewManager.getLayer(DefaultLayers.Banners).getCurrentScene()
                .sceneTextFields
        ) {
            const announcer = ViewManager.getLayer(DefaultLayers.Banners)
                .getCurrentScene()
                .sceneTextFields.get("anouncer");
            announcer.visible = true;
            announcer.text = SpinModel.freespinsNum + " spins left";
        } else {
            ConsoleUtil.warn("[UI] MISSING UI ELEMENT -> Free spins announcer");
        }
    }
}
